import React from 'react';
import { Heart } from 'lucide-react';

export const ProudSupporter = () => {
  const supporters = [
    {
      name: 'Wholesome Wave Georgia',
      logo: '/assets/images/must-ministries-logo.webp',
      url: 'https://www.wholesomewavegeorgia.org/'
    },
    {
      name: 'New American Pathways',
      logo: '/assets/images/new-american-pathways-logo.png',
      url: 'https://newamericanpathways.org/'
    }
  ];

  return (
    <section className="relative overflow-hidden">
      {/* Background with navy to teal gradient */}
      <div 
        className="absolute inset-0 bg-gradient-to-br from-navy-600 via-navy-700 to-teal-800"
      />
      
      {/* Teal accent overlay on top */}
      <div 
        className="absolute inset-0 bg-gradient-to-r from-transparent via-teal-500/10 to-transparent"
      />
      
      {/* Background pattern/texture overlay with teal */}
      <div 
        className="absolute inset-0 opacity-15"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2340E0D0' fill-opacity='0.6'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />
      
      {/* Teal glow effect */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-teal-400/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-teal-500/15 rounded-full blur-3xl" />

      {/* Top teal border accent */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-teal-400 to-transparent" />

      {/* Bottom teal wave decoration */}
      <div className="absolute bottom-0 left-0 right-0 h-24">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path d="M0 120L60 100L120 110L180 80L240 90L300 60L360 70L420 40L480 50L540 20L600 30L660 10L720 20L780 40L840 30L900 50L960 20L1020 40L1080 10L1140 30L1200 50L1260 30L1320 60L1380 40L1440 70V120H0Z" fill="url(#tealGradient)"/>
          <defs>
            <linearGradient id="tealGradient" x1="0" y1="0" x2="1440" y2="0">
              <stop offset="0%" stopColor="#008080" stopOpacity="0.3"/>
              <stop offset="50%" stopColor="#40E0D0" stopOpacity="0.4"/>
              <stop offset="100%" stopColor="#008080" stopOpacity="0.3"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      
      <div className="relative z-10 py-16 md:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* CBS Logo */}
          <div className="flex justify-center mb-12">
            <img
              src="/assets/images/cbs-logo.png"
              alt="Capital Billing Services"
              loading="lazy"
              decoding="async"
              width="200"
              height="80"
              className="h-20 md:h-24 w-auto"
            />
          </div>
          
          {/* Proud Supporter Section */}
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-10">
              PROUD SUPPORTER OF
            </h2>
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
              {supporters.map((supporter, index) => (
                <a
                  key={index}
                  href={supporter.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group transition-all hover:scale-105"
                >
                  {supporter.logo ? (
                    <div className="bg-white/10 backdrop-blur-sm rounded-2xl px-6 py-4 border border-white/20 hover:bg-white/20 hover:border-teal-400/50 transition-all duration-300">
                      <img
                        src={supporter.logo}
                        alt={supporter.name}
                        loading="lazy"
                        decoding="async"
                        width="160"
                        height="80"
                        className="h-16 md:h-20 w-auto object-contain"
                      />
                    </div>
                  ) : (
                    <div className="bg-white/10 backdrop-blur-sm rounded-2xl px-8 py-6 border border-white/20 hover:bg-white/20 hover:border-teal-400/50 transition-all duration-300">
                      <div className="flex items-center gap-3">
                        <Heart 
                          className="w-8 h-8 text-teal-400 group-hover:text-teal-300 transition-colors" 
                          fill="currentColor"
                        />
                        <span className="text-white text-xl md:text-2xl font-semibold italic">
                          {supporter.name}
                        </span>
                      </div>
                    </div>
                  )}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
